<template>
  <div>
    <InputRadio
      v-for="(option, i) in options"
      :key="`${option.label}-${option.value}-${i}`"
      v-model="selectedValue"
      :label="option.label"
      :name="`${options}`"
      :inputValue="option"
      :checked="option.checked || false"
      class="filter-dropdown-list--input"
      @change="$emit('input', selectedValue)"
    />
  </div>
</template>

<script>
/**
 * Componente que compõe o FilterDropdown
 */
import { getRandomInt } from '@/helpers/math'
import InputRadio from '@/components/_base/elements/InputRadio'

export default {
  name: 'FilterDropdownRadio',
  components: {
    InputRadio
  },
  props: {
    /**
     * Array de objetos das opções
     * Obj exemplo:
     * {
     *  label: 'Nome da opção',
     *  value: 0,
     *  checked: false
     * }
     */
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      name: `radio-${getRandomInt(0, 1000)}`,
      selectedValue: ''
    }
  },
  created() {
    this.selectedValue = this.options.filter((item) => item.checked)[0]

    this.$emit('input', this.selectedValue)
  }
}
</script>

<style lang="scss" scoped>
.filter-dropdown-list {
  &--input + &--input {
    margin-top: 18px;
  }
}
</style>
